// hooks/useSelector.js
import { useState, useCallback } from 'react';

export const useSelector = (options = {}) => {
  const {
    endpoint,
    onSelect: externalOnSelect,
    title = 'Seleccionar',
    columns = [],
    searchFields = ['Codigo', 'Nombre'],
    extraParams = {},
    rowKey = 'Codigo',
    pageSize = 10,
    width = 800,
    searchPlaceholder = 'Buscar por código o nombre...',
    dataKey = 'data',
    paginationKey = 'pagination',
    searchParam = 'search',
    renderItem = null,
    showActionColumn = true,
    actionText = 'Seleccionar',
    onRowDoubleClick = null,
    formatData = null
  } = options;

  const [visible, setVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const open = useCallback(() => {
    setVisible(true);
    setSelectedRecord(null);
  }, []);

  const close = useCallback(() => {
    setVisible(false);
  }, []);

  const handleSelect = useCallback((record) => {
    setSelectedRecord(record);
    setVisible(false);
    if (externalOnSelect) {
      externalOnSelect(record);
    }
  }, [externalOnSelect]);

  return {
    visible,
    open,
    close,
    selectedRecord,
    handleSelect,
    modalProps: {
      visible,
      onClose: close,
      onSelect: handleSelect,
      title,
      endpoint,
      columns,
      searchFields,
      extraParams,
      rowKey,
      pageSize,
      width,
      searchPlaceholder,
      dataKey,
      paginationKey,
      searchParam,
      renderItem,
      showActionColumn,
      actionText,
      onRowDoubleClick,
      formatData
    }
  };
};